import { render, staticRenderFns } from "./InvestPlanTab.vue?vue&type=template&id=22d4d488&scoped=true"
import script from "./InvestPlanTab.vue?vue&type=script&lang=js"
export * from "./InvestPlanTab.vue?vue&type=script&lang=js"
import style0 from "./InvestPlanTab.vue?vue&type=style&index=0&id=22d4d488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d4d488",
  null
  
)

export default component.exports